<template>
	<div class="products">
		<div class="gradient"></div>
		<div class="container p-0">
			<div v-if="screenWidth > 1024" class="content">
				<div
					v-for="pc in productCategoreis"
					class="col-6 pr-2 pl-2 mb-4 col-lg-3 float-right z-10"
				>
					<router-link
						class="item"
						:to="{
							name: 'products',
							params: {
								id: pc.productCategoryId,
								name: pc.name.replace(/ /gi, '-')
							}
						}"
					>
						<div class="details">
							<label>{{ pc.name }}</label>
						</div>
						<div class="inner">
							<div
								class="img"
								v-bind:style="{
									'background-image':
										'url(' +
										rootImagePath +
										pc.imagePath +
										')'
								}"
							></div>
						</div>
					</router-link>
				</div>
			</div>
			<swiper
				:options="swiperOption"
				v-if="screenWidth <= 1024"
				class="content"
			>
				<swiper-slide
					v-for="(pc, index) in productCategoreis"
					:key="index"
					class="col-6 pr-2 pl-2 col-lg-3 float-right z-10"
				>
					<router-link
						class="item"
						:to="{
							name: 'products',
							params: {
								id: pc.productCategoryId,
								name: pc.name.replace(/ /gi, '-')
							}
						}"
					>
						<div class="details">
							<label>{{ pc.name }}</label>
						</div>
						<div class="inner">
							<div
								class="img"
								v-bind:style="{
									'background-image':
										'url(' +
										rootImagePath +
										pc.imagePath +
										')'
								}"
							></div>
						</div>
					</router-link>
				</swiper-slide>
				<div class="swiper-button-next" slot="button-next"></div>
				<div class="swiper-button-prev" slot="button-prev"></div>
			</swiper>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		rootImagePath: {
			type: String
		},

		productCategoreis: {
			type: Array
		}
	},

	beforeMount() {
		this.screenWidth = window.outerWidth;
	},

	data() {
		return {
			screenWidth: 0,
			swiperOption: {
				loop: true,
				slidesPerView: "auto",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				}
			}
		};
	}
};
</script>
<style scoped>
.products {
	width: 100%;
	float: right;
	text-align: center;
	position: relative;
	margin-top: -300px;
	z-index: 10;
}

.products .gradient {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 400px;
	background: rgba(234, 237, 237, 0);
	background: linear-gradient(
		to bottom,
		rgba(234, 237, 237, 0) 0%,
		rgba(234, 237, 237, 0.88) 36%,
		rgba(234, 237, 237, 1) 58%,
		rgba(234, 237, 237, 1) 100%
	);
}

.products .content {
	width: 100%;
	float: right;
}

.products .content .item {
	transition: all 0.5s;
	width: 100%;
	height: 370px;
	display: inline-block;
	padding: 10px;
	background: #fff;
}

.products .content .item .inner {
	width: 100%;
	height: 300px;
	float: right;
	position: relative;
}

.products .content .item .img {
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	width: 100%;
	height: 300px;
}

.products .content .item .details {
	width: 100%;
	color: #000;
	text-align: right;
	font-weight: bold;
	font-size: 16px;
}

@media (max-width: 1024px) {
	.products {
		margin-top: -180px;
	}

	.products .gradient {
		height: 230px;
	}

	.products .content .item {
		height: 230px;
		margin-bottom: 10px;
		padding: 5px;
	}

	.products .content .item .inner,
	.products .content .item .img {
		height: 190px;
	}

	.products .content .item .details {
		font-size: 14px;
	}
}

.z-10 {
	z-index: 10;
}
</style>
